<template>
  <div class="color-slate-600 inline-flex flex-row gap-2 items-center py-1">
    <template v-if="isFilterActive">
      <AppIcon :icon="['fal', 'filter']" />
      Resultaten zijn gefilterd.
      <button
        class="color-dark-500 underline decoration-dotted"
        @click.prevent="clearFilters()"
      >
        Filters wissen
      </button>
    </template>
    <button
      class="color-dark-500 underline decoration-dotted"
      @click.prevent="refresh"
    >
      Verversen
    </button>
  </div>
</template>

<script lang="ts">
export default {
  setup(props: any) {
    const isFilterActive = ref(false);
    function refresh() {
      props.params.onRefresh()
    }

    function clearFilters() {
      props.params?.api.setFilterModel(null);
    }

    function setFiltersActive(active: boolean) {
      isFilterActive.value = active;
    }

    return {
      setFiltersActive,
      clearFilters,
      isFilterActive,
      refresh
    };
  }
};
</script>
